function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];
  
  removeTrapFocus();
  
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  
  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    
    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  
  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
          if (model.modelViewerUI){
             model.modelViewerUI.pause();
          }
        });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  let i = 0, count = selector.options.length;
  for (; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};
  
  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  
  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    const value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  
  initProvince: function () {
    const value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  
  countryHandler: function (e) {
    let opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute('data-provinces');
    const provinces = JSON.parse(raw);
    
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      
      this.provinceContainer.style.display = "";
    }
  },
  
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  
  setOptions: function (selector, values) {
    let count = values.length;
    for (let i = 0; i < count; i++) {
      const opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class DiscountComponent extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('click', (e) => {
      const Input = document.createElement('input');
      Input.value = e.target.dataset.discount;
      document.body.appendChild(Input);
      Input.select();
      document.execCommand("Copy");
      Input.remove();
      UIkit.notification({message: 'Copied', pos: 'center', status: 'success'})
    });
  }
}

customElements.define('discount-component', DiscountComponent)

class TabFilter extends HTMLElement {
  constructor() {
    super();
    this.updateSections();
    this.querySelectorAll('[data-filter-tab]').forEach((element) => {
      element.addEventListener('click', (event) => {
        event.target.closest('ul').querySelectorAll('li').forEach(e => e.classList.remove('tm-active'))
        event.target.closest('li').classList.add('tm-active');
        this.updateSections(event.target.dataset.filterTab);
      }, false);
    })
  }
  
  /**
   * update tabs state
   * @param activeSection
   */
  updateSections(activeSection) {
    const activeTab = activeSection ? activeSection : 'group_1';
    document.querySelectorAll('[data-filter]').forEach(elem => elem.classList.add('uk-hidden'));
    document.querySelectorAll(`[data-filter="${activeTab}"]`).forEach(elem => elem.classList.remove('uk-hidden'));
  }
}

customElements.define('tab-filter', TabFilter);



class backToTop extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('scroll', () => {
      this.classList.toggle('uk-hidden', document.documentElement.scrollTop <= 600);
    });
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', backToTop);
}


class Cookie extends HTMLElement {
  constructor() {
    super();
    const config = {
      name: 'consent-tracking-api', version: '0.1'
    }
    window.Shopify.loadFeatures([config], (error) => {
      if (error) {
        throw error;
      }
      setTimeout(() => {
        this.initCookieBanner();
      }, 3000)
    });
    
    this.addEventListener('hide', () => {
      this.handleAccept();
    });
    
    // this.acceptBtn.addEventListener('click', this.handleAccept.bind(this));
    // this.declineBtn.addEventListener('click', this.handleDecline.bind(this));
  }
  
  toggleCookie(show = true) {
    this.classList.toggle('active', show)
  }
  
  handleAccept(e) {
    const {customerPrivacy} = window.Shopify;
    customerPrivacy.setTrackingConsent(true, this.toggleCookie.bind(this, false));
    document.addEventListener('trackingConsentAccepted', () => {
      
    });
  }
  
  handleDecline() {
    const {customerPrivacy} = window.Shopify;
    customerPrivacy.setTrackingConsent(false, this.toggleCookie.bind(this, false));
  }
  
  initCookieBanner() {
    const {customerPrivacy} = window.Shopify;
    const userCanBeTracked = customerPrivacy.userCanBeTracked();
    const userTrackingConsent = customerPrivacy.getTrackingConsent();
    if (userCanBeTracked && userTrackingConsent === 'no_interaction') {
      this.toggleCookie();
    } else {
      this.remove();
    }
  }
}

if (!customElements.get('cookie-banner')) {
  customElements.define('cookie-banner', Cookie);
}


class SectionRedirect extends HTMLElement {
  constructor() {
    super();
    this.time = this.dataset.time;
    this.timer = null;
    this.timeText = this.querySelector('[data-time]');
    this.redirectUrl = this.querySelector('[href]').getAttribute('href');
    this.init();
  }
  
  init() {
    clearInterval(this.timer);
    this.timeText.innerText = `${this.time}s`;
    this.timer = setInterval(() => {
      this.timeText.innerText = `${--this.time}s`;
      if (this.time <= 0) {
        clearInterval(this.timer);
        this.redirect(this.redirectUrl);
      }
    }, 1000)
  }
  
  redirect(url = '/') {
    if (!Shopify.designMode) {
      window.location.href = url;
    }
  }
}

if (!customElements.get('section-redirect')) {
  customElements.define('section-redirect', SectionRedirect);
}


class CountdownTime extends HTMLElement {
  constructor() {
    super();
    let timer = null;
    const {time} = this.dataset;
    // Date.parse('2022-03-09T15:58:20+08:00'); 1646812700000
    const countdown = UIkit.countdown(this, {date: time});
    this.classList.toggle('uk-hidden', !countdown.timer);
    
    timer = setInterval(() => {
      if (Date.parse(time) - new Date().getTime() < 0) {
        this.remove();
        clearInterval(timer);
      }
    }, 100);
  }
}

if (!customElements.get('countdown-time')) {
  customElements.define('countdown-time', CountdownTime);
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {bubbles: true})
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }
  
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value){
      this.input.dispatchEvent(this.changeEvent);
      let type = this.dataset.type;
      // console.log('type', type)
      if(type == 'product') {
        updateIntegral({
          type: 'product',
          domId: 'integral-product',
          quantity: this.input.value
        })
      }
    } 
  }
}

customElements.define('quantity-input', QuantityInput);

/**
  预估获得积分提示
*/
async function updateIntegral({domId = '',productList = [],type = null,quantity = 1}) {
  // 获取活动列表
  var activityList = []
  var storedProductList = localStorage.getItem('activityList');
  // 获取存储的时间
  var storageTime = parseInt(localStorage.getItem('storageTime'));
  if (storageTime) {
    // 检查是否过了30分钟
    if (new Date().getTime() - storageTime > 30 * 60 * 1000) {
      // 如果过了30分钟，从本地存储中移除数据
      localStorage.removeItem('activityList');
      localStorage.removeItem('storageTime');
      localStorage.setItem('storageTime', new Date().getTime())
      getactivityList((data) => {
      activityList = data;
      // console.log('存储过期', activityList)
      setIntegralData(domId,productList,activityList,type,quantity);
      localStorage.setItem('storageTime', new Date().getTime());
       if(activityList)localStorage.setItem('activityList', JSON.stringify(activityList));
    })
    }else {
      // 如果未过期，将存储的产品列表字符串转换回数组
      activityList = JSON.parse(storedProductList);
      setIntegralData(domId,productList,activityList,type,quantity)
      // console.log('存储30分钟内',activityList)
    }
  }else {
     getactivityList((data) => {
      activityList = data
      // console.log('第一次进来', activityList)
      setIntegralData(domId,productList,activityList,type,quantity)
      localStorage.setItem('storageTime', new Date().getTime())
       if(activityList)localStorage.setItem('activityList', JSON.stringify(activityList));
    })
  }
}
async function getactivityList(callback) {
  await fetch('https://admin.bluettipower.com/orderapi/autoPointsSkus/list',  {method: 'GET',headers: {'shop': window.Shopify.shop.split(".myshopify.com")[0]}})
  .then(response => response.json())
  .then( res => {
    callback && callback(res.data);
  });
}
function setIntegralData(domId,productList,activityList,type,quantity) {
  var integralBox = document.getElementById(domId);
  // console.log('integralBox',integralBox)
  var myIntegral = integralBox.querySelector('.integral');
  // console.log('myIntegral',myIntegral)
  var myEstimatedPrice = integralBox.querySelector('.estimated-price');
  if(!myIntegral)return;
  if(productList.length <= 0) {
      productList = JSON.parse(myIntegral.getAttribute("data-product-list"));
  }
  var points = 0
  if(type != 'product') {
    // 会员等级倍数
    var memberLevelMultiplier = myIntegral.getAttribute("data-member-level").split(',');
    // 会员等级默认0;
    var userLevel  = 1; 
    // 获取vip等级
    var customerTags = myIntegral.getAttribute("data-customer-tages");
    let match = customerTags.match(/vip(\d+)/);
    if (match) {
      userLevel = match[1] - 1;
      // console.log('登录成功会员倍数', memberLevelMultiplier[userLevel]); 
    }else {
      // console.log('未登录', memberLevelMultiplier[userLevel]); 
    }
    // 获取活动列表最高倍数
    function getHighestMultiple(data, productSku) {
        let highestMultiple = 0; // 默认最高倍数为0
        if(data){
          for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].skus.length; j++) {
              if (productSku === data[i].skus[j] && data[i].multiple > highestMultiple) {
                  highestMultiple = data[i].multiple;
              }
            }
          }
        }
        return highestMultiple;
    }
    for (var i = 0; i < productList.length; i++) {
      if(productList[i].quantity) {
        points += productList[i].price / 100 * productList[i].quantity * ( 1 * getHighestMultiple(activityList, productList[i].sku) + ( 1 * userLevel ))
      }else {
        points += productList[i].price / 100 * ( 1 * getHighestMultiple(activityList, productList[i].sku) + ( 1 * userLevel ))
      }
       // console.log('sku', productList[i].sku,'价格',productList[i].price/100 ,'数量',productList[i].quantity,'活动倍数', getHighestMultiple(activityList, productList[i].sku), '会员倍数', userLevel, "积分", productList[i].price / 100 * productList[i].quantity * ( 1 * getHighestMultiple(activityList, productList[i].sku) + ( 1 * userLevel )) )
    }
  }else {
    points = productList[0].price * quantity / 100;
  }
  myIntegral.style.display = 'none'; // 先隐藏节点
  myEstimatedPrice.style.display = 'none'; // 先隐藏节点
  myIntegral.innerHTML = Math.floor(points);
  myEstimatedPrice.innerHTML = Math.round(points / 100);
  myIntegral.style.display = 'inline-block';
  myEstimatedPrice.style.display = 'inline-block';
}